export const COMPONENT_NAME = "admin-config-currency-modal";
